import { render } from "./SettingsIcon.vue?vue&type=template&id=53ca37f6&scoped=true"
const script = {}

import "./SettingsIcon.vue?vue&type=style&index=0&id=53ca37f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ca37f6"]])

export default __exports__